import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path d="M58.6664 29.5465V31.9998C58.6631 37.7503 56.801 43.3456 53.3579 47.9513C49.9148 52.5571 45.0751 55.9264 39.5606 57.5569C34.0462 59.1873 28.1524 58.9915 22.7583 56.9987C17.3642 55.0059 12.7588 51.3227 9.6289 46.4986C6.49905 41.6746 5.01245 35.968 5.39081 30.23C5.76917 24.492 7.99223 19.03 11.7284 14.6587C15.4646 10.2873 20.5138 7.24082 26.1228 5.97352C31.7319 4.70623 37.6004 5.28603 42.853 7.62647"
            stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M58.6667 10.6665L32 37.3598L24 29.3598"
            stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);
export default Icon;